module.exports = __webpack_public_path__ + "user4/user4-0d89f666766028017cc1c76c08216e06.png";